import { Bar } from 'react-chartjs-2';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
} from '@material-ui/core';

import PropTypes from 'prop-types';
import { useState } from 'react';

const NumberOfDownloads = ({ graphdata, currentYear,requestDataForYear, rz, graphdata1, rz1, ...rest }) => {
  const theme = useTheme();
  const labels = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  const [year, setYear] = useState(currentYear)

  if(graphdata.lenght === 0) {
    graphdata.push({month:1, value:0,datacenterId:0})
  }
  if(graphdata1.lenght === 0) {
    graphdata1.push({month:1, value:0,datacenterId:0})
  }

  const data = {
    labels,
    labels,
    datasets: [
      {
        label: rz,
        data: graphdata.map((data) => data.value.toFixed(2)),
        backgroundColor: "rgba(27, 102, 179, 0.2)",
      },
      {
        label: rz1,
        data: graphdata1.map((data) => data.value.toFixed(2)),
        backgroundColor: "rgba(27, 102, 179, 1)",
      }
    ],
    //labels: graphdata.map((data) => data.month)
  };

  const options = {
    animation: false,
    barThickness: 17,
    cornerRadius: 5,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
          display: false
      }
  },
    scales: {
      x: 
        {
          barThickness: 12,
          maxBarThickness: 10,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
          ticks: {
            fontColor: theme.palette.text.secondary
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }
      ,
      y: 
        {
          ticks: {
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0
          },
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          }
        }
      
    },
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary,
    }
  };
  // const options = {
  //   animation: false,
  //   layout: { padding: 0 },
  //  legend: { display: true },
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: {
  //       display: true
  //     }
  //   },

  //   tooltips: {
  //     backgroundColor: theme.palette.background.paper,
  //     bodyFontColor: theme.palette.text.secondary,
  //     borderColor: theme.palette.divider,
  //     borderWidth: 1,
  //     enabled: true,
  //     footerFontColor: theme.palette.text.secondary,
  //     intersect: false,
  //     mode: 'index',
  //     titleFontColor: theme.palette.text.primary,
  //   }
  // };

  let yearOptions = new Array()
  let diff = new Date().getFullYear() - 2021 + 1

  for (let i = 0; i < diff; i++) {
    yearOptions.push(new Date().getFullYear() - i)
  }

  const handleYearChange = (event) => {
    setYear(event.target.value)
    requestDataForYear(event.target.value)
  }

  return (
    <Card {...rest}>
      <CardHeader
        action={(
          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="jahrInputLabel">Jahr</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="jahrSelect"
              value={year}
              onChange={handleYearChange}
            >
              {yearOptions.map((y) => (
                <MenuItem key={y} value={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        title={`RZ Verbrauch pro Monat`}
      />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 500,
            position: 'relative'
          }}
        >
          <Bar
            data={data}
            options={options}

          />
        </Box>
      </CardContent>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
      </Box>
    </Card>
  );
};

NumberOfDownloads.propTypes = {
  rzdata: PropTypes.any,
  rz1data: PropTypes.any,
};

export default NumberOfDownloads;
